import { schema } from "normalizr"

import item from "../activityDetails/item"

export default new schema.Array(item)
